import { Accepts, Types } from "@citychallenge/common";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class FormProps {
  @Inlet(Accepts.Image) public media?: Types["Image"];
  @Inlet(Accepts.MarkdownText) public text?: Types["MarkdownText"];
  @Inlet(Accepts.FormInputList) public form?: Types["FormInputList"];

  @Inlet(Accepts.OptInType) public optInType?: Types["OptInType"];
  @Inlet(Accepts.MarkdownText) public optInText?: Types["MarkdownText"];
  @Inlet(Accepts.String) public optInConsentKey?: Types["String"];
}

export const FormDefinition = defineElement("form", FormProps, {
  versionRequired: "0.62.1",
});
